import Modal from './Modal'

export default Modal


// WEBPACK FOOTER //
// ./src/components/shared/elements/Modal/index.js